import React, { useEffect, useState } from 'react';
import { GetRemainedWallet } from '../adapters/GetRemainedWallet';
import EditablePersianSupportNumericTextField from 'Global/Components/EditableComponents/EditablePersianSupportNumericTextField';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { Cached } from '@mui/icons-material';

const WalletBalance = () => {
  const [fetchBalance, setFetchBalance] = useState(false);
  const [balance, setBalance] = useState(0);
  useEffect(() => {
    GetRemainedWallet(setBalance);
  }, [fetchBalance]);

  const balance_label = FindLangKey(
    'genral-public-label-wallet-balance'
  );

  return (
    <React.Fragment>
      <EditablePersianSupportNumericTextField
        label={balance_label}
        iconFn={() => {
          setFetchBalance((prev) => !prev);
        }}
        icon={<Cached />}
        value={balance}
        enableSeperator
      />
    </React.Fragment>
  );
};

export default WalletBalance;
